import styled, { css } from "styled-components";
import { EllipsisDropdownItem } from "@similarweb/ui-components";
import {
    ButtonVariant,
    colorByVariant,
    primaryElementFont,
} from "app/pages/sales-intelligence/sub-modules/signals/components/filters/shared/styles";

export const StyledDropdownItemWithCheckboxAndWrapping = styled(EllipsisDropdownItem)<{
    isPrimary?: boolean;
}>`
    display: flex;
    padding-right: 11px;

    ${({ isPrimary = false }) => {
        if (isPrimary) {
            return css`
                ${primaryElementFont(colorByVariant[ButtonVariant.Default])};

                font-weight: 500;
            `;
        }
    }};

    div {
        white-space: initial;
    }
`;
